export var Issuer;
(function (Issuer) {
    Issuer['appAuth'] = 'appAuth';
})(Issuer || (Issuer = {}));
